export default function (lotes) {
  let window = 'termoAlienacao'
  !this.$uloc.printView.get(window) && this.$uloc.printView.new({
    wid: window,
    title: 'Termo de Alienacão',
    windowClass: 'erp-print',
    contentClass: '',
    props: {
      lotes: lotes.slice().map(l => l && l.id ? l.id : l)
    }
  }, () => import('@/components/pda/print/views/TermoAlienacao'))
    .then((wid) => {
    }) // return wid
}
